import { mapState, mapActions } from "vuex"
import merge from "lodash/merge"

export default {
  props: {
    onSet: {
      type: Function,
      required: false,
    },
  },
  render() {
    return this.$scopedSlots.default({
      dimension: this.dimension,
      set: this.set,
      submit: this.submit,
    })
  },
  methods: {
    set(attr) {
      const { name, value } = event.target
      const newValue = {
        [attr]: {
          [name]: value === "" ? null : parseInt(value),
        },
      }

      this.setDimension(merge(this.dimension, newValue))
      this.onSet?.()
    },
    submit() {
      this.mergeDimensions()
    },
    ...mapActions("filter", ["setDimension", "mergeDimensions"]),
  },
  computed: {
    ...mapState("filter", ["dimension"]),
  },
}
